import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingMatrixNoTime } from '../../../../mechanics/rid-reading-matrix-no-time/rid-reading-matrix-no-time';

@Component({
  selector: 'app-reading-matrix-no-time-page',
  imports: [RidReadingMatrixNoTime],
  templateUrl: './reading-matrix-no-time-page.html',
})
export class ReadingMatrixNoTimePage {
  protected readonly $router = inject(Router);
}
